import React from "react";
import { AreaChartOutlined, IdcardOutlined, SendOutlined, UnorderedListOutlined, WarningOutlined, WhatsAppOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import InsideHeader from "../../components/InsideHeader";
import "./whatsapp.css";

const modules = [
  {
    title: "WhatsApp Dashboard",
    description: "Track queue health, delivery trends, read rates, and failure hotspots",
    path: "/whatsapp-dashboard",
    icon: <AreaChartOutlined />,
  },
  {
    title: "Send WhatsApp Messages",
    description: "Create single or bulk WhatsApp sends with templates or text messages",
    path: "/whatsapp-send",
    icon: <SendOutlined />,
  },
  {
    title: "WhatsApp Numbers",
    description: "Register sender phone numbers, display names, and business profile details",
    path: "/whatsapp-numbers",
    icon: <IdcardOutlined />,
  },
  {
    title: "WhatsApp Message Queue",
    description: "Monitor pending, sent, delivered, read, and failed outbound messages",
    path: "/whatsapp-queue",
    icon: <UnorderedListOutlined />,
  },
  {
    title: "Dead Letter",
    description: "Review messages that exhausted retries and moved to failed handling",
    path: "/whatsapp-dead-letter",
    icon: <WarningOutlined />,
  },
];

const WhatsAppHome = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full h-full overflow-y-scroll whatsapp-page">
      <InsideHeader title="WhatsApp" subtitle="Register sender numbers, send, and monitor outbound WhatsApp messages" back={false} />

      <div className="whatsapp-home-shell">
        <div className="whatsapp-home-title">
          <div className="whatsapp-home-icon">
            <WhatsAppOutlined />
          </div>
          <div>
            <h1>WhatsApp</h1>
            <p>Sender registration, messaging, queue monitoring, analytics, and failed-message review.</p>
          </div>
        </div>

        <div className="whatsapp-home-grid">
          {modules.map((item) => (
            <button key={item.path} type="button" className="whatsapp-module-card" onClick={() => navigate(item.path)}>
              <span className="whatsapp-module-icon">{item.icon}</span>
              <span className="whatsapp-module-copy">
                <strong>{item.title}</strong>
                <span>{item.description}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhatsAppHome;
